import { Alert, Button, Checkbox, Icon, message, Modal } from "antd";
import { ExecutionResult, FetchResult } from "apollo-boost";
import gql from "graphql-tag";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useApolloClient, useMutation, useQuery } from "react-apollo-hooks";
import { castSketchSaveArgs } from "src/util/helper";
// import screenshot from 'src/util/screenshot';
import screenshot from "src/util/screenshot";

import { APP_SETTING, REFETCH_PRODUCT_INFO } from "../query/query";
import Background from "./Background";
import ImageItem from "./ImageItem";
import {
  WrapAlert,
  WrapButton,
  WrapConfirmPreview,
  WrapHighWarnning,
  WrapPreview,
} from "./index.styled";
import SvgTextItem from "./SvgTextItem";
import TextItem from "./TextItem";

export default (props) => {
  const { data: appSetting } = useQuery(APP_SETTING);
  const client = useApolloClient();
  const { id, sno } = props.data;

  const [showModal, setModal] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [previewPath, setPreviewPath] = useState(props.data.s3FilePath);
  const [showResetModal, setShowResetModal] = useState(false);
  const [applyEnable, setApplyEnable] = useState(true);
  const [makeImageButtonDisabled, setMakeImageButtonDisabled] = useState(true);

  const RUN_EDIT_MODE = gql`
    mutation RunEditMode($currentEditProductId: String!, $sno: String!) {
      runEditMode(currentEditProductId: $currentEditProductId, sno: $sno)
        @client
    }
  `;

  const [RunEditMode] = useMutation(RUN_EDIT_MODE, {
    variables: { currentEditProductId: id, sno },
  });

  const RESET_SKETCH_HISTORY = gql`
    mutation ResetSketchHistory($ordno: ID!) {
      resetSketchHistory(ordno: $ordno) {
        success
        message
      }
    }
  `;

  const [ResetSketchHistory] = useMutation(RESET_SKETCH_HISTORY, {
    variables: {
      ordno: appSetting.app.ordno,
    },
  });

  const SUBMIT_IMAGE_TO_SERVER = gql`
    mutation SubmitImage(
      $data: String
      $id: String
      $ordno: String
      $browser: String
      $sno: String
    ) {
      submitImage(
        data: $data
        id: $id
        ordno: $ordno
        browser: $browser
        sno: $sno
      ) {
        success
        message
        s3FilePath
      }
    }
  `;

  const SKETCH_SAVE_MUTATION = gql`
    mutation SkechSave(
      $data: [SketchInfo]
      $id: String
      $ordno: String
      $sno: String
    ) {
      sketchSave(data: $data, id: $id, ordno: $ordno, sno: $sno) {
        success
        message
      }
    }
  `;
  const [SubmitImageMutation] = useMutation(SUBMIT_IMAGE_TO_SERVER);
  const [sketchSave] = useMutation(SKETCH_SAVE_MUTATION);

  const SubmitImage = () => {
    setSubmitLoading(true);

    const elementTarget = document.getElementById(sno + "-" + id);

    if (elementTarget) {
      screenshot.buildPngDataURL(elementTarget).then((svgImage) => {
        SubmitImageMutation({
          variables: {
            data: svgImage,
            id,
            sno: sno + "",
            ordno: appSetting.app.ordno,
            browser: appSetting.app.browser,
          },
          update: (cache, response: FetchResult<any>) => {
            if (!response.data.submitImage.success) {
              message.error(
                "이미지를 서버에 저장하는데 실패 했습니다. 고객센터로 문의주세요. 1544-9560"
              );
            } else {
              const fragment = gql`
                fragment CompleteVariablesFragment on ProductInfo {
                  isCompleted
                }
              `;
              const oldIsCompleted: any = cache.readFragment({
                fragment,
                id: sno + "|" + id,
              });
              const newData = {
                ...oldIsCompleted,
                isCompleted: true,
              };

              cache.writeData({
                id: sno + "|" + id,
                data: newData,
              });

              setTimeout(() => {
                setPreviewPath(response.data!.submitImage.s3FilePath);
              }, 1000);
            }

            setSubmitLoading(false);
            setModal(false);
          },
        });
      });
    }
  };

  useEffect(() => {
    setPreviewPath(props.data.s3FilePath);
    if (props.data.s3FilePath === "") {
      setMakeImageButtonDisabled(false);
    }
  }, [props.data.s3FilePath]);

  const resetDesign = (lookupHistory) => {
    ResetSketchHistory({
      refetchQueries: (mutationResult: ExecutionResult<any>) => {
        if (mutationResult.data.resetSketchHistory.success) {
          return [
            {
              query: REFETCH_PRODUCT_INFO,
              variables: {
                ordno: appSetting.app.ordno,
                productId: id,
                lookupHistory: true,
                sno: sno + "",
              },
            },
          ];
        } else {
          return [];
        }
      },
      update: (cache, response: FetchResult<any>) => {
        if (response.data.resetSketchHistory.success) {
          cache.writeData({
            data: {
              app: {
                __typename: "AppSetting",
                currentEditProductId: 0,
                currentSno: 0,
              },
            },
          });
        } else {
          message.error(response.data.resetSketchHistory.message);
        }
      },
    });
  };

  return (
    <WrapPreview>
      <Modal
        visible={showModal}
        title="디자인 최종컨펌 및 제출하기"
        onCancel={() => setModal(false)}
        closable={false}
        footer={[
          <Button
            type="ghost"
            onClick={() => setModal(false)}
            key={"cancel"}
            loading={submitLoading}
          >
            좀더 검토할게요!
          </Button>,
          <Button
            type="primary"
            onClick={() => {
              const targetProduct = client.readFragment({
                id: sno + "|" + id,
                fragment: gql`
                  fragment targetProductFragment on ProductInfo {
                    items {
                      id
                      type
                      editable
                      contents
                      addStyle
                    }
                  }
                `,
              });

              const { items } = targetProduct;
              let newItems = _.clone(items);

              newItems = _.remove(newItems, (x: any) => x.editable);

              setSubmitLoading(true);

              sketchSave({
                variables: {
                  id,
                  sno: sno + "",
                  ordno: props.orderInfo.ordno,
                  data: castSketchSaveArgs(newItems),
                },
                update: (cache, response: FetchResult<any>) => {
                  const fragment = gql`
                    fragment CompleteVariablesFragment on ProductInfo {
                      isCompleted
                    }
                  `;
                  const oldIsCompleted: any = cache.readFragment({
                    fragment,
                    id: sno + "|" + id,
                  });
                  const newData = {
                    ...oldIsCompleted,
                    isCompleted: true,
                  };

                  cache.writeData({
                    id: sno + "|" + id,
                    data: newData,
                  });

                  setSubmitLoading(false);
                  setModal(false);
                },
              });

              // setSubmitLoading(false);
              // setModal(false);
            }}
            loading={submitLoading}
            key={"ok"}
            disabled={applyEnable}
          >
            디자인 제출할게요!
          </Button>,
        ]}
      >
        입력하신 내용은 제작시 다시 검수되지 않으며, 오탈자 등은 작성자의
        책임입니다. 위내용에 동의하시는 경우 아래체크박스에 체크해주시면 시안을
        확정하실수 있습니다.
        <br />
        <br />
        <Checkbox
          onChange={(obj) => {
            if (obj.target.checked) {
              setApplyEnable(false);
            } else {
              setApplyEnable(true);
            }
          }}
        >
          <WrapHighWarnning>위내용을 숙지하였으며 동의합니다.</WrapHighWarnning>
        </Checkbox>
        {submitLoading && (
          <Alert
            message="파일을 전송중입니다"
            description="시안처리가 완료될때까지 기다려주세요. 10초정도 소요됩니다."
            type="info"
            showIcon={true}
            style={{ marginTop: "10px" }}
          />
        )}
      </Modal>

      <Alert
        type="info"
        message={
          <>
            <Icon type="arrow-down" />
            &nbsp;
            {props.data.cakeName}
          </>
        }
        style={{ marginBottom: "10px" }}
      />
      <div id={sno + "-" + id} className="previewWindow">
        {props.data.isCompleted && previewPath ? (
          <WrapConfirmPreview>
            <img
              width="100%"
              src={`http://s3.cakefactory.co.kr/${previewPath}`}
            />
          </WrapConfirmPreview>
        ) : (
          <Background data={props.data}>
            {props.data.items.map((currentData) => {
              switch (currentData.type) {
                case "TEXT":
                case "TEXTAREA":
                case "TEXTAREA_WITH_LINEHEIGHT":
                  return <TextItem key={currentData.id} data={currentData} />;
                case "SVGTEXT":
                  return (
                    <SvgTextItem key={currentData.id} data={currentData} />
                  );
                case "IMAGE":
                  return (
                    <ImageItem
                      key={sno + "-" + currentData.id}
                      data={currentData}
                      sno={sno}
                    />
                  );
                default:
                  return <TextItem key={currentData.id} data={currentData} />;
              }
            })}
          </Background>
        )}
      </div>
      {!props.data.isCompleted ? (
        <WrapButton>
          <Button onClick={() => RunEditMode()}>내용변경하기</Button>

          <Button
            type="primary"
            onClick={() => setModal(true)}
            disabled={submitLoading}
          >
            디자인확정하기
          </Button>
        </WrapButton>
      ) : props.orderInfo.isEditable ? (
        <WrapAlert>
          <Alert
            type="success"
            message="디자인 제출이 완료되었습니다. 지금 보여지는 이미지가 최종본입니다."
          />
          <div className="reset-button">
            <WrapButton>
              <Button
                type="primary"
                size="small"
                onClick={() => {
                  setShowResetModal(true);
                }}
              >
                수정하기
              </Button>
              {props.orderInfo.isAdmin && (
                <Button
                  className="process-image-button"
                  type="danger"
                  size="small"
                  loading={submitLoading}
                  disabled={makeImageButtonDisabled}
                  onClick={({ target }) => {
                    SubmitImage();
                    // 부모의 disabled 속성을 true 로 변경
                    setMakeImageButtonDisabled(true);
                  }}
                >
                  이미지로변경
                </Button>
              )}
            </WrapButton>
          </div>
          <Modal
            title="확인해주세요"
            visible={showResetModal}
            onOk={() => {
              resetDesign(true);
              setShowResetModal(false);
            }}
            onCancel={() => {
              setShowResetModal(false);
            }}
            okText={"네 이해했습니다"}
            cancelText={"수정안할래요"}
          >
            <div>
              디자인을 수정하고 반드시
              <WrapHighWarnning>디자인확정하기</WrapHighWarnning>를 클릭해
              주셔야 수정된 디자인으로 반영됩니다.
            </div>
            <p>내용을 숙지하셨나요?</p>
          </Modal>
        </WrapAlert>
      ) : (
        <WrapAlert>
          <Alert
            type="success"
            message="디자인 최종확정 상태입니다. 추가적인 문의가 있으신경우 고객센터로 문의 부탁드립니다. 1544-9560"
          />
        </WrapAlert>
      )}
    </WrapPreview>
  );
};



// WEBPACK FOOTER //
// ./src/components/preview/index.tsx